import { MessageCircle, GraduationCap } from 'lucide-react';
import { BRAND } from '@/data/content';
import { useCounsellingModal } from './CounsellingModal';

const FloatingButtons = () => {
  const { open } = useCounsellingModal();

  return (
    <div className="floating-buttons" data-testid="floating-buttons">
      <button
        className="float-btn book"
        onClick={() => open({ source: 'floating_cta' })}
        data-testid="floating-book-btn"
      >
        <GraduationCap size={18} />
        <span>Book Free Counselling</span>
      </button>
      <a
        href={`https://wa.me/${BRAND.whatsapp}?text=Hi%20EuroElite,%20I%20am%20interested%20in%20studying%20abroad`}
        target="_blank"
        rel="noopener noreferrer"
        className="float-btn whatsapp"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp"
      >
        <MessageCircle size={26} />
        <span className="pulse"></span>
      </a>
    </div>
  );
};

export default FloatingButtons;
